import { z } from 'zod';
import { EntityType } from '$lib/sanity/types';
import { SanityBlockSchema, SanityDocumentSchema } from '../sanity';
import { SEOSchema } from '../shared/SEO';

export const LegalCookiePageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.LegalCookiePage),
  seoAttributes: SEOSchema.nullish(),
  pageContent: z.array(SanityBlockSchema).optional()
});

export type LegalCookiePage = z.infer<typeof LegalCookiePageSchema>;
